import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";
import { POLE_TIMEOUT_MS, isPoleNotSetUp, reportDeviceFailure, reportPoleSuccess } from "../hardware/hardwareStatus";
import { buildDisplayLines } from "./CWPoleDisplay";

const PoleDisplay = (PoleDisplayData, type, dueAmount) => {
  // CW Browser (Electron) exposes a native serial/HTTP pole display bridge —
  // use it directly and skip the legacy hardware-controller Axios call.
  if (window.electronAPI?.hardware?.updateDisplaySmart) {
    const [line1, line2] = buildDisplayLines(PoleDisplayData, type, dueAmount);
    console.log(`[poleDisplay] Electron path — type="${type}" line1="${line1}" line2="${line2}"`);
    window.electronAPI.hardware
      .updateDisplaySmart("auto", line1, line2)
      .then((result) => {
        if (result?.success) {
          console.log(`[poleDisplay] updateDisplaySmart succeeded for type="${type}"`);
        } else {
          console.warn(`[poleDisplay] updateDisplaySmart failed for type="${type}":`, result?.error);
        }
      })
      .catch((err) => console.warn(`[poleDisplay] updateDisplaySmart threw for type="${type}":`, err?.message));
    return;
  }

  let data = "";
  if (type === "Quantity update") {
    data = `
            <line>
                <text align="left" length="15">${PoleDisplayData.name}</text>
                <text align="right" length="5">x${PoleDisplayData.weight}</text>
            </line>
            <line>
                <text align="right" length="20">${PoleDisplayData.realPrice}</text>
                <text align="right" length="20">${parseInt(PoleDisplayData.realPrice * PoleDisplayData.weight)}</text>
            </line>`;
  } else if (type === "Add item to cart") {
    data = `
            <line>
                <text align="left" length="15">${PoleDisplayData.name}</text>
                <text align="right" length="5">x${PoleDisplayData.weight}</text>
            </line>
            <line>
                <text align="right" length="20">${PoleDisplayData.realPrice}</text>
            </line>`;
  } else if (type === "Total to pay" || type === "Show due payment" || type === "Show payment success") {
    data = `
            <line>
                <text align="left" length="10">Total.</text>
                <text align="right" length="10">${PoleDisplayData.total}</text>
            </line>`;
    if (type === "Total to pay") {
      data += `
                <line>
                    <text align="left" length="10">Remaining to Pay</text>
                    <text align="right" length="10">${PoleDisplayData.total}</text>
                </line>`;
    } else if (type === "Show due payment") {
      data += `
                <line>
                    <text align="left" length="10">Remaining to Pay</text>
                    <text align="right" length="10">${dueAmount ? parseInt(PoleDisplayData.total - dueAmount) : ""}</text>
                </line>`;
    } else if (type === "Show payment success") {
      data += `
                <line>
                    <text align="center" length="20">Thank you.</text>
                </line>`;
    }
  }

  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;
  if (!printerURL) {
    console.warn(`[poleDisplay] No hardwareController.imageUrl configured — skipping (type="${type}")`);
    return;
  }
  // The Controller said this till has no customer display port set: stop sending for this session.
  if (isPoleNotSetUp()) return;

  let PoleDisplayPayload = `<?xml version="1.0" encoding="UTF-8"?>
    <output>
        <display>
            ${data}
        </display>
    </output>`;
  Axios.post(`${printerURL}printer`, PoleDisplayPayload, {
    notAPrint: true,
    timeout: POLE_TIMEOUT_MS,
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
      console.log(`[poleDisplay] Axios path succeeded for type="${type}"`);
      reportPoleSuccess();
    })
    .catch((err) => {
      console.warn(`[poleDisplay] Axios path failed for type="${type}":`, err?.message);
      reportDeviceFailure("pole", err);
    });
};
export default PoleDisplay;
